import { Alert, Button, Form, Input, message, Modal, Space, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RequisitionMemoActivitesTable from "./RequisitionMemoActivitesTable";
import RequisitionMemoOtherDetails from "./RequisitionMemoOtherDetails";
import appConfig from "../../../../config/config.json";
import generateRequisitionMemoPdf from "../../../../config/services/requisitionMemoPdf";
import { getCurrency } from "../../../../config/helpers/app/numberFormater";
import { rejectionsActions } from "../../../../config/actions/rejections/rejections.actions";
import AddPaymentVoucher from "../../paymentVouchers/Forms/AddPaymentVoucher";
import paymentVoucherThunks from "../../../../config/thunks/finance/paymentVoucher/paymentVoucher.thunks";
import requisitionMemoThunks from "../../../../config/thunks/finance/requisitionMemo/requisitionMemo.thunks";

const { TextArea } = Input;

const { TabPane } = Tabs;

const RequisitionMemoDetails = ({
  visible,
  handleCloseModal,
  handleApproveRequisitionMemo,
  handleUndoApproveRequisitionMemo,
  handleSubmitRequisititionMemo,
  handleReviewRequisitionMemo,
  handleCheckRequisitionMemo,
  handleOpenAddActivityModal,
  handleRefreshData,
  handleDeleteActivity,
  handleOpenEditModal,
  handleOpenViewDetails,
}) => {
  const {
    requisitionMemosDetailsLoading,
    requisitionMemosDetailsSuccess,
    requisitionMemosDetailsError,
    requisitionMemosDetails,
    approveRequisitionMemosLoading,
    approveRequisitionMemosSuccess,
    approveRequisitionMemosError,
    approveRequisitionMemosMessage,
    checkRequisitionMemosLoading,
    checkRequisitionMemosSuccess,
    checkRequisitionMemosError,
    checkRequisitionMemosMessage,
    submitRequisitionMemosLoading,
    submitRequisitionMemosSuccess,
    submitRequisitionMemosError,
    submitRequisitionMemosMessage,
    undoApproveRequisitionMemosLoading,
    undoApproveRequisitionMemosSuccess,
    undoApproveRequisitionMemosMessage,
    undoApproveRequisitionMemosError,
    reviewRequisitionMemosLoading,
    reviewRequisitionMemosSuccess,
    reviewRequisitionMemosError,
    reviewRequisitionMemosMessage,
  } = useSelector((state) => state.requisitionMemoState);
  const {
    addPaymentVouchersSuccess,
    addPaymentVouchersError,
    addPaymentVouchersMessage,
  } = useSelector((state) => state.paymentVouchersState);
  const currency = getCurrency(
    requisitionMemosDetails?.projectDetails,
    "approved_budget"
  );
  const dispatch = useDispatch();
  const [approvalFormVisible, setApprovalFormVisible] = useState(false);
  const [paymentVoucherModalVisible, setPaymentVoucherModalVisible] =
    useState(false);
  const [pendingCheck, setPendingCheck] = useState(false);
  const closeModal = () => handleCloseModal(false);
  const refreshActivities = () => handleRefreshData(requisitionMemosDetails.id);
  const submit = () =>
    handleSubmitRequisititionMemo(requisitionMemosDetails.id);
  const check = () => {
    setPendingCheck(true);
    openPaymentVoucherModal();
  };
  const openApprovalForm = () => setApprovalFormVisible(true);
  const handleApprovalSubmit = (formData) => {
    handleApproveRequisitionMemo(requisitionMemosDetails.id, formData);
    setApprovalFormVisible(false);
  };
  const review = () => handleReviewRequisitionMemo?.(requisitionMemosDetails.id);
  const undoApprove = () =>
    handleUndoApproveRequisitionMemo?.(requisitionMemosDetails.id);

  const openPaymentVoucherModal = () => {
    setPaymentVoucherModalVisible(true);
    dispatch(paymentVoucherThunks.paymentVouchersMetaData());
  };
  const closePaymentVoucherModal = () => {
    setPaymentVoucherModalVisible(false);
  };
  const handleAddPaymentVoucher = (values, paymentVouchers) => {
    dispatch(paymentVoucherThunks.addPaymentVouchers(values, paymentVouchers));
  };
  const exportRequisitionMemo = () => {
    requisitionMemosDetails.status === appConfig.status.approved
      ? generateRequisitionMemoPdf(requisitionMemosDetails, currency)
      : message.info("Requisition form has not yet been approved");
  };
  const reject = () => {
    dispatch(
      rejectionsActions.toggleRejectionsModal({
        visible: true,
        data: {
          user_to_id: requisitionMemosDetails?.created_by,
          item_application: "Requisition Memos",
          item_id: requisitionMemosDetails?.id,
          itemName: `Requisition Memo ${requisitionMemosDetails.memo_number}`,
        },
      })
    );
  };
  useEffect(() => {
    if (undoApproveRequisitionMemosSuccess && undoApproveRequisitionMemosMessage)
      message.success(undoApproveRequisitionMemosMessage);
    else if (!undoApproveRequisitionMemosSuccess && undoApproveRequisitionMemosError)
      message.error(undoApproveRequisitionMemosError);
    if (approveRequisitionMemosSuccess && approveRequisitionMemosMessage) {
      message.success(approveRequisitionMemosMessage);
      setApprovalFormVisible(false);
    } else if (!approveRequisitionMemosSuccess && approveRequisitionMemosError)
      message.error(approveRequisitionMemosError);
    if (submitRequisitionMemosSuccess && submitRequisitionMemosMessage)
      message.success(submitRequisitionMemosMessage);
    else if (!submitRequisitionMemosSuccess && submitRequisitionMemosError)
      message.error(submitRequisitionMemosError);
    if (checkRequisitionMemosSuccess && checkRequisitionMemosMessage)
      message.success(checkRequisitionMemosMessage);
    else if (!checkRequisitionMemosSuccess && checkRequisitionMemosError)
      message.error(checkRequisitionMemosError);
    if (reviewRequisitionMemosSuccess && reviewRequisitionMemosMessage)
      message.success(reviewRequisitionMemosMessage);
    else if (!reviewRequisitionMemosSuccess && reviewRequisitionMemosError)
      message.error(reviewRequisitionMemosError);
    if (addPaymentVouchersSuccess && addPaymentVouchersMessage) {
      message.success(addPaymentVouchersMessage);
      setPaymentVoucherModalVisible(false);
      if (pendingCheck && requisitionMemosDetails?.id) {
        handleCheckRequisitionMemo(requisitionMemosDetails.id);
      }
      setPendingCheck(false);
    }
  }, [
    addPaymentVouchersMessage,
    addPaymentVouchersSuccess,
    approveRequisitionMemosError,
    approveRequisitionMemosMessage,
    approveRequisitionMemosSuccess,
    checkRequisitionMemosError,
    checkRequisitionMemosMessage,
    checkRequisitionMemosSuccess,
    submitRequisitionMemosError,
    submitRequisitionMemosMessage,
    submitRequisitionMemosSuccess,
    pendingCheck,
    undoApproveRequisitionMemosSuccess,
    undoApproveRequisitionMemosMessage,
    undoApproveRequisitionMemosError,
    reviewRequisitionMemosSuccess,
    reviewRequisitionMemosMessage,
    reviewRequisitionMemosError,
  ]);
  return (
    <div>
      <Modal
        zIndex={500}
        width={800}
        onCancel={closeModal}
        open={visible}
        title={`REQUISITION FORM - ${
          requisitionMemosDetails.memo_number || "LOADING..."
        }`}
        footer={[
          requisitionMemosDetails.status !== appConfig.status.rejected && (
            <Space key="actions">
              {requisitionMemosDetails.status === appConfig.status.approved && (
                <Button
                  onClick={undoApprove}
                  loading={undoApproveRequisitionMemosLoading}
                  type="primary"
                  danger
                >
                  Undo Approval
                </Button>
              )}
              {requisitionMemosDetails.status !== appConfig.status.approved && (
                <>
                  {requisitionMemosDetails.submitted && (
                    <Space>
                      <Button
                        onClick={openApprovalForm}
                        loading={approveRequisitionMemosLoading}
                        type="primary"
                      >
                        Approve
                      </Button>
                      {requisitionMemosDetails.status !== appConfig.status.checked && (
                        <Button onClick={check} loading={checkRequisitionMemosLoading}>
                          Check
                        </Button>
                      )}
                      {!requisitionMemosDetails.reviewer && handleReviewRequisitionMemo && (
                        <Button onClick={review} loading={reviewRequisitionMemosLoading}>
                          Review
                        </Button>
                      )}
                      <Button onClick={reject} danger>
                        Reject
                      </Button>
                    </Space>
                  )}
                  {!requisitionMemosDetails.submitted && (
                    <Button
                      loading={submitRequisitionMemosLoading}
                      className="bg-light"
                      type="dashed"
                      onClick={submit}
                    >
                      Submit
                    </Button>
                  )}
                </>
              )}
            </Space>
          ),
        ]}
      >
        {requisitionMemosDetailsLoading ? (
          <div className="justify-content-center d-flex m-5">
            <Spin />
          </div>
        ) : (
          <div>
            {!requisitionMemosDetailsSuccess ? (
              <Alert
                type="error"
                showIcon
                message={requisitionMemosDetailsError}
              />
            ) : (
              <div>
                {!addPaymentVouchersSuccess && addPaymentVouchersError && (
                  <Alert showIcon message={addPaymentVouchersError} />
                )}
                <Tabs defaultActiveKey="1">
                  <TabPane tab="Activities" key="1">
                    <RequisitionMemoActivitesTable
                      handleExportRecords={exportRequisitionMemo}
                      handleViewDetails={handleOpenViewDetails}
                      handleOpenEditModal={handleOpenEditModal}
                      handleDelete={handleDeleteActivity}
                      handleRefreshTable={refreshActivities}
                      handleOpenAddModal={handleOpenAddActivityModal}
                    />
                  </TabPane>
                  <TabPane tab="Other Details" key="2">
                    <RequisitionMemoOtherDetails
                      data={requisitionMemosDetails}
                    />
                  </TabPane>
                </Tabs>
              </div>
            )}
          </div>
        )}
      </Modal>
      {approvalFormVisible && (
        <Modal
          zIndex={1000}
          footer={null}
          onCancel={() => setApprovalFormVisible(false)}
          title="APPROVAL"
          open={approvalFormVisible}
        >
          <Form
            layout="vertical"
            onFinish={(values) => {
              handleApprovalSubmit(values);
            }}
            validateTrigger="onBlur"
          >
            <Form.Item
              name="comment"
              label="Approval Comment"
              rules={[
                { required: true, message: "Please add an approval comment" },
              ]}
            >
              <TextArea
                rows={4}
                placeholder="Enter your approval comment"
              />
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                loading={approveRequisitionMemosLoading}
              >
                Approve
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}
      <AddPaymentVoucher
        visible={paymentVoucherModalVisible}
        handleCloseModal={closePaymentVoucherModal}
        handleAddRecord={handleAddPaymentVoucher}
        initialRequisitionMemoId={requisitionMemosDetails?.id}
        initialRequisitionMemo={requisitionMemosDetails}
      />
    </div> 
  );
};

export default RequisitionMemoDetails;
